import { call, put } from 'redux-saga/effects'
import { GET_TOP_PRODUCTS_RESPONSE, GET_TOP_PRODUCTS_ERROR } from '../actions/actionCreator'
import { getTopProductsAPI } from '../api'
// eslint-disable-next-line
export function * topProductsSaga () {
  try {
    yield put(GET_TOP_PRODUCTS_RESPONSE({ request: true }))
    const data = yield call(getTopProductsAPI)
    yield put(GET_TOP_PRODUCTS_RESPONSE({ request: false, data: data, error: false }))
  } catch (error) {
    yield put(GET_TOP_PRODUCTS_ERROR({ request: true, error: error }))
  }
}
